import React from 'react';


export const Lambda = props => {
    return (
        <img className={props.className} src={require('../../../../resources/images/aws_icons/lambda.png')} />
    )
};
